/**
 * Bilingual building directory and intelligent query matching for Mae Fah Luang University (MFU).
 *
 * Provides deterministic, sub-millisecond Thai <-> English alias resolution
 * covering all 99 MFU campus buildings, dormitories, academic centers, and property units.
 */

export const MFU_BUILDING_DIRECTORY = [
  // 1-8: Staff Housing (A1 & A2)
  {
    code: 'A1-1 อาคารชุดที่พักอาจารย์และบุคลากรโสด',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรโสด A1-1',
    en: 'Staff Housing A1-1 (Single)',
    aliases: ['a1-1', 'a1 1', 'a11', 'a1', 'staff housing a1-1', 'single staff a1-1', 'แฟลตอาจารย์ a1-1']
  },
  {
    code: 'A1-2 อาคารชุดที่พักอาจารย์และบุคลากรโสด',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรโสด A1-2',
    en: 'Staff Housing A1-2 (Single)',
    aliases: ['a1-2', 'a1 2', 'a12', 'staff housing a1-2', 'single staff a1-2', 'แฟลตอาจารย์ a1-2']
  },
  {
    code: 'A1-3 อาคารชุดที่พักอาจารย์และบุคลากรโสด',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรโสด A1-3',
    en: 'Staff Housing A1-3 (Single)',
    aliases: ['a1-3', 'a1 3', 'a13', 'staff housing a1-3', 'single staff a1-3', 'แฟลตอาจารย์ a1-3']
  },
  {
    code: 'A1-4 อาคารชุดที่พักอาจารย์และบุคลากรโสด',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรโสด A1-4',
    en: 'Staff Housing A1-4 (Single)',
    aliases: ['a1-4', 'a1 4', 'a14', 'staff housing a1-4', 'single staff a1-4', 'แฟลตอาจารย์ a1-4']
  },
  {
    code: 'A2-1 อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว A2-1',
    en: 'Staff Housing A2-1 (Family)',
    aliases: ['a2-1', 'a2 1', 'a21', 'a2', 'staff housing a2-1', 'family staff a2-1', 'แฟลตครอบครัว a2-1']
  },
  {
    code: 'A2-2 อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว A2-2',
    en: 'Staff Housing A2-2 (Family)',
    aliases: ['a2-2', 'a2 2', 'a22', 'staff housing a2-2', 'family staff a2-2', 'แฟลตครอบครัว a2-2']
  },
  {
    code: 'A2-3 อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว A2-3',
    en: 'Staff Housing A2-3 (Family)',
    aliases: ['a2-3', 'a2 3', 'a23', 'staff housing a2-3', 'family staff a2-3', 'แฟลตครอบครัว a2-3']
  },
  {
    code: 'A2-4 อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว',
    th: 'อาคารชุดที่พักอาจารย์และบุคลากรครอบครัว A2-4',
    en: 'Staff Housing A2-4 (Family)',
    aliases: ['a2-4', 'a2 4', 'a24', 'staff housing a2-4', 'family staff a2-4', 'แฟลตครอบครัว a2-4']
  },

  // 9-12: Administration & Core Services
  {
    code: 'AD สำนักงานอธิการบดี',
    th: 'สำนักงานอธิการบดี (AD)',
    en: 'President Office Building (AD)',
    aliases: ['ad', 'president office', 'สำนักงานอธิการบดี', 'อธิการบดี', 'ad building', 'ตึกad']
  },
  {
    code: 'AD2 อาคารบริหารกลาง',
    th: 'อาคารบริหารกลาง (AD2)',
    en: 'Central Administration Building (AD2)',
    aliases: ['ad2', 'ad-2', 'central admin', 'central administration', 'บริหารกลาง', 'ตึกad2']
  },
  {
    code: 'AS อาคารบริการวิชาการ',
    th: 'อาคารบริการวิชาการ (AS)',
    en: 'Academic Services Building (AS)',
    aliases: ['as', 'academic services', 'academic service', 'บริการวิชาการ', 'ตึกas']
  },
  {
    code: 'AV ศูนย์บรรณสารและการศึกษา(ห้องสมุด)',
    th: 'ศูนย์บรรณสารและการศึกษา ห้องสมุด (AV)',
    en: 'Learning Resource Center & Library (AV)',
    aliases: ['av', 'library', 'resource center', 'ห้องสมุด', 'บรรณสาร', 'ตึกav', 'ศูนย์บรรณสาร', 'หอสมุด']
  },

  // 13-17: Lecture & Auditorium Buildings (C1-C5)
  {
    code: 'C1 อาคารเรียนรวม 1',
    th: 'อาคารเรียนรวม 1 (C1)',
    en: 'Classroom Building 1 (C1)',
    aliases: ['c1', 'classroom 1', 'lecture 1', 'เรียนรวม 1', 'เรียนรวม1', 'ตึกc1', 'อาคารเรียนรวม 1']
  },
  {
    code: 'C2 อาคารเรียนรวม 2',
    th: 'อาคารเรียนรวม 2 (C2)',
    en: 'Classroom Building 2 (C2)',
    aliases: ['c2', 'classroom 2', 'lecture 2', 'เรียนรวม 2', 'เรียนรวม2', 'ตึกc2', 'อาคารเรียนรวม 2']
  },
  {
    code: 'C3 อาคารเรียนรวม 3',
    th: 'อาคารเรียนรวม 3 (C3)',
    en: 'Classroom Building 3 (C3)',
    aliases: ['c3', 'classroom 3', 'lecture 3', 'เรียนรวม 3', 'เรียนรวม3', 'ตึกc3', 'อาคารเรียนรวม 3']
  },
  {
    code: 'C4 หอประชุมสมเด็จย่า',
    th: 'หอประชุมสมเด็จย่า (C4)',
    en: 'Princess Srinagarindra Auditorium (C4)',
    aliases: ['c4', 'somdej ya', 'auditorium', 'srinagarindra', 'หอประชุม', 'สมเด็จย่า', 'ตึกc4']
  },
  {
    code: 'C5 อาคารพลตำรวจ เอกเภา สารสิน',
    th: 'อาคาร พล.ต.อ.เภา สารสิน (C5)',
    en: 'Pol.Gen. Pao Sarasin Building (C5)',
    aliases: ['c5', 'pao', 'sarasin', 'pao sarasin', 'เภา', 'สารสิน', 'ตึกc5', 'พลตำรวจเอกเภา']
  },

  // 18-19: Chinese Student Dorms
  {
    code: 'CN1 หอพักนักศึกษาภาษาจีน 1 (ประเสริญ - ทัศนีย์พุ่งกุมาร)',
    th: 'หอจีน 1 (หอพักประเสริฐฯ)',
    en: 'Chinese Dormitory 1 (Prasert Dormitory)',
    aliases: ['cn1', 'cn 1', 'chinese dorm 1', 'หอจีน 1', 'หอพักจีน 1', 'ประเสริฐ', 'ประเสริญ', 'prasert', 'พุ่งกุมาร']
  },
  {
    code: 'CN2 หอพักนักศึกษาภาษาจีน 1 (บุญทรง - เพียงใจ)',
    th: 'หอจีน 2 (หอพักบุญทรงฯ)',
    en: 'Chinese Dormitory 2 (Bunsong Dormitory)',
    aliases: ['cn2', 'cn 2', 'chinese dorm 2', 'หอจีน 2', 'หอพักจีน 2', 'บุญทรง', 'bunsong', 'เพียงใจ']
  },

  // 20-21: D Buildings
  {
    code: 'D1 อาคารโรงอาหาร',
    th: 'ศูนย์อาหาร D1',
    en: 'D1 Food Court',
    aliases: ['d1', 'canteen d1', 'cafeteria d1', 'โรงอาหาร d1', 'โรงอาหารd1', 'ตึกd1', 'canteen']
  },
  {
    code: 'D2 โครงการจัดตั้งพิพิธภัณฑ์อารยธรรมลุ่มแม่น้ำโขง มหาวิทยาลัยแม่ฟ้าหลวง',
    th: 'พิพิธภัณฑ์อารยธรรมลุ่มน้ำโขง (D2)',
    en: 'Mekong Civilization Museum (D2)',
    aliases: ['d2', 'mekong museum', 'museum d2', 'พิพิธภัณฑ์', 'ลุ่มน้ำโขง', 'ตึกd2']
  },

  // 22-27: E Buildings & Parks
  {
    code: 'E-Park (Education Park)',
    th: 'Education Park (E-Park)',
    en: 'Education Park (E-Park)',
    aliases: ['e-park', 'epark', 'education park', 'อีปาร์ค']
  },
  {
    code: 'E1 อาคารสำนักวิชา 1',
    th: 'อาคารสำนักวิชา 1 (E1)',
    en: 'School Building 1 (E1)',
    aliases: ['e1', 'school building 1', 'สำนักวิชา 1', 'สำนักวิชา1', 'ตึกe1']
  },
  {
    code: 'E2 อาคารสำนักวิชา 2',
    th: 'อาคารสำนักวิชา 2 (E2)',
    en: 'School Building 2 (E2)',
    aliases: ['e2', 'school building 2', 'สำนักวิชา 2', 'สำนักวิชา2', 'ตึกe2']
  },
  {
    code: 'E3-A อาคารสำนักวิชา 3',
    th: 'อาคารสำนักวิชา 3 (E3-A)',
    en: 'School Building 3 (E3-A)',
    aliases: ['e3-a', 'e3a', 'school building 3a', 'สำนักวิชา 3a', 'ตึกe3a']
  },
  {
    code: 'E3-B อาคารสำนักวิชา 3',
    th: 'อาคารสำนักวิชา 3 (E3-B)',
    en: 'School Building 3 (E3-B)',
    aliases: ['e3-b', 'e3b', 'school building 3b', 'สำนักวิชา 3b', 'ตึกe3b']
  },
  {
    code: 'E4 อาคารพลเอกสำเภา ชูศรี',
    th: 'อาคารพลเอก สำเภา ชูศรี (E4)',
    en: 'General Sampao Choosri Building (E4)',
    aliases: ['e4', 'sampao', 'choosri', 'สำเภา', 'ชูศรี', 'พลเอกสำเภา', 'ตึกe4', 'gen sampao']
  },

  // 28-33: Female Dormitories (F1-F6)
  {
    code: 'F1 หอพักนักศึกษาหญิงF1',
    th: 'หอพักนักศึกษาหญิง F1',
    en: 'Female Dormitory F1',
    aliases: ['f1', 'dorm f1', 'หอ f1', 'หอf1', 'dormitory f1', 'female dorm f1', 'ตึกf1']
  },
  {
    code: 'F2 หอพักนักศึกษาหญิงF2',
    th: 'หอพักนักศึกษาหญิง F2',
    en: 'Female Dormitory F2',
    aliases: ['f2', 'dorm f2', 'หอ f2', 'หอf2', 'dormitory f2', 'female dorm f2', 'ตึกf2']
  },
  {
    code: 'F3 หอพักนักศึกษาหญิงF3',
    th: 'หอพักนักศึกษาหญิง F3',
    en: 'Female Dormitory F3',
    aliases: ['f3', 'dorm f3', 'หอ f3', 'หอf3', 'dormitory f3', 'female dorm f3', 'ตึกf3']
  },
  {
    code: 'F4 หอพักนักศึกษาหญิงF4',
    th: 'หอพักนักศึกษาหญิง F4',
    en: 'Female Dormitory F4',
    aliases: ['f4', 'dorm f4', 'หอ f4', 'หอf4', 'dormitory f4', 'female dorm f4', 'ตึกf4']
  },
  {
    code: 'F5 หอพักนักศึกษาหญิงF5',
    th: 'หอพักนักศึกษาหญิง F5',
    en: 'Female Dormitory F5',
    aliases: ['f5', 'dorm f5', 'หอ f5', 'หอf5', 'dormitory f5', 'female dorm f5', 'ตึกf5']
  },
  {
    code: 'F6 หอพักนักศึกษาหญิงF6',
    th: 'หอพักนักศึกษาหญิง F6',
    en: 'Female Dormitory F6',
    aliases: ['f6', 'dorm f6', 'หอ f6', 'หอf6', 'dormitory f6', 'female dorm f6', 'ตึกf6']
  },

  // 34-39: Residences (H1-H5)
  {
    code: 'H1 บ้านพักอธิการบดี',
    th: 'บ้านพักอธิการบดี (H1)',
    en: 'President Residence 1 (H1)',
    aliases: ['h1', 'president residence', 'บ้านพักอธิการบดี', 'h1 residence']
  },
  {
    code: 'H2 บ้านพักผู้บริหาร',
    th: 'บ้านพักผู้บริหาร (H2)',
    en: 'Executive Residence (H2)',
    aliases: ['h2', 'executive residence', 'บ้านพักผู้บริหาร']
  },
  {
    code: 'H2 บ้านพักอธิการบดี หลังที่ 2',
    th: 'บ้านพักอธิการบดี หลังที่ 2 (H2)',
    en: 'President Residence 2 (H2)',
    aliases: ['h2-2', 'president residence 2', 'บ้านพักอธิการบดี 2']
  },
  {
    code: 'H3 บ้านพักวนาเวศน์',
    th: 'บ้านพักวนาเวศน์ (H3)',
    en: 'Wanawes Residence (H3)',
    aliases: ['h3', 'wanawes residence', 'wanawet residence', 'วนาเวศน์', 'บ้านพักวนาเวศน์', 'wanawes', 'wanawet', 'vanaves']
  },
  {
    code: 'H4 บ้านพักอาจารย์ และบุคลากร',
    th: 'บ้านพักอาจารย์และบุคลากร (H4)',
    en: 'Faculty & Staff Residence (H4)',
    aliases: ['h4', 'staff residence h4', 'faculty residence', 'บ้านพักอาจารย์ h4']
  },
  {
    code: 'H5 บ้านพักอาจารย์',
    th: 'บ้านพักอาจารย์ (H5)',
    en: 'Faculty Residence (H5)',
    aliases: ['h5', 'faculty residence h5', 'บ้านพักอาจารย์ h5']
  },

  // 40-46: Parks, IB, M-Square, M3, Wellness
  {
    code: 'I-Park (Innovation Park)',
    th: 'Innovation Park (I-Park)',
    en: 'Innovation Park (I-Park)',
    aliases: ['i-park', 'ipark', 'innovation park', 'ไอปาร์ค']
  },
  {
    code: 'IB หอพักนักศึกษานานาชาติ (หอพักเภา สารสิน)',
    th: 'หอพักนักศึกษานานาชาติ เภา สารสิน (IB)',
    en: 'International Student Dormitory (IB)',
    aliases: ['ib', 'international dorm', 'inter dorm', 'หอนานาชาติ', 'หอพักนานาชาติ', 'หอib', 'เภา สารสิน']
  },
  {
    code: 'L-Park (Liftstyle Park)',
    th: 'Lifestyle Park (L-Park)',
    en: 'Lifestyle Park (L-Park)',
    aliases: ['l-park', 'lpark', 'lifestyle park', 'แอลปาร์ค']
  },
  {
    code: 'M-Square',
    th: 'อาคารเอ็มสแควร์ (M-Square)',
    en: 'M-Square Building',
    aliases: ['m-square', 'msquare', 'm square', 'เอ็มสแควร์', 'เอ็มสแควร', 'ตึก m-square']
  },
  {
    code: 'M-Store',
    th: 'ร้านค้าเอ็มสโตร์ (M-Store)',
    en: 'M-Store Shop',
    aliases: ['m-store', 'mstore', 'm store', 'เอ็มสโตร์', 'เอ็มสโตร']
  },
  {
    code: 'M3 อาคารปรีคลินิก',
    th: 'อาคารปรีคลินิก (M3)',
    en: 'Pre-Clinic Building (M3)',
    aliases: ['m3', 'preclinic', 'pre-clinic', 'ปรีคลินิก', 'ตึกm3']
  },
  {
    code: 'MFU Wellness Center',
    th: 'ศูนย์บริการสุขภาพแบบครบวงจรแห่งภาคเหนือ (MFU Wellness Center)',
    en: 'MFU Wellness Center',
    aliases: ['wellness', 'mfu wellness', 'wellness center', 'ศูนย์เวลเนส', 'เวลเนส']
  },

  // 47-54: Science Labs (S1-S7)
  {
    code: 'S1 อาคารปฎิบัติการทางวิทยาศาสตร์และเทคโนโลยี 1',
    th: 'อาคารปฏิบัติการทางวิทยาศาสตร์และเทคโนโลยี 1 (S1)',
    en: 'Science & Technology Laboratory 1 (S1)',
    aliases: ['s1', 'science lab 1', 'ตึกs1', 'แล็บs1', 'วิทย์ 1']
  },
  {
    code: 'S2 อาคารปฎิบัติการทางวิทยาศาสตร์และเทคโนโลยี 2',
    th: 'อาคารปฏิบัติการทางวิทยาศาสตร์และเทคโนโลยี 2 (S2)',
    en: 'Science & Technology Laboratory 2 (S2)',
    aliases: ['s2', 'science lab 2', 'ตึกs2', 'แล็บs2', 'วิทย์ 2']
  },
  {
    code: 'S3 อาคารปฎิบัติการทางวิทยาศาสตร์และเทคโนโลยี 3',
    th: 'อาคารปฏิบัติการทางวิทยาศาสตร์และเทคโนโลยี 3 (S3)',
    en: 'Science & Technology Laboratory 3 (S3)',
    aliases: ['s3', 'science lab 3', 'ตึกs3', 'แล็บs3', 'วิทย์ 3']
  },
  {
    code: 'S4 อาคารปฎิบัติการทางวิทยาศาสตร์และเทคโนโลยี 4',
    th: 'อาคารปฏิบัติการทางวิทยาศาสตร์และเทคโนโลยี 4 (S4)',
    en: 'Science & Technology Laboratory 4 (S4)',
    aliases: ['s4', 'science lab 4', 'ตึกs4', 'แล็บs4', 'วิทย์ 4']
  },
  {
    code: 'S5 อาคารปฎิบัติการทางวิทยาศาสตร์และเทคโนโลยี 5',
    th: 'อาคารปฏิบัติการทางวิทยาศาสตร์และเทคโนโลยี 5 (S5)',
    en: 'Science & Technology Laboratory 5 (S5)',
    aliases: ['s5', 'science lab 5', 'ตึกs5', 'แล็บs5', 'วิทย์ 5']
  },
  {
    code: 'S6 อาคารปฎิบัติการทางวิทยาศาสตร์และเทคโนโลยี 6',
    th: 'อาคารปฏิบัติการทางวิทยาศาสตร์และเทคโนโลยี 6 (S6)',
    en: 'Science & Technology Laboratory 6 (S6)',
    aliases: ['s6', 'science lab 6', 'ตึกs6', 'แล็บs6', 'วิทย์ 6']
  },
  {
    code: 'S7-A อาคารศูนย์การเรียนรู้ภาษา/อาคารศูนย์วิจัย',
    th: 'ศูนย์การเรียนรู้ภาษาและศูนย์วิจัย (S7-A)',
    en: 'Language Learning & Research Center (S7-A)',
    aliases: ['s7-a', 's7a', 's7', 'language learning', 'research center', 'ศูนย์ภาษา s7a']
  },
  {
    code: 'S7-B อาคารศูนย์การเรียนรู้ภาษา/อาคารศูนย์วิจัย',
    th: 'ศูนย์การเรียนรู้ภาษาและศูนย์วิจัย (S7-B)',
    en: 'Language Learning & Research Center (S7-B)',
    aliases: ['s7-b', 's7b', 'language learning b', 'ศูนย์ภาษา s7b']
  },

  // 55: Test / UAT
  {
    code: 'UAT-E1',
    th: 'อาคารทดสอบ UAT-E1',
    en: 'UAT-E1 Test Building',
    aliases: ['uat-e1', 'uat e1', 'uate1']
  },

  // 56-66: Property, Commercial, Services
  {
    code: 'กลุ่มร้านค้าอาคาร M-Square',
    th: 'กลุ่มร้านค้าอาคาร M-Square',
    en: 'M-Square Retail Shops',
    aliases: ['m-square shop', 'msquare shops', 'ร้านค้า m-square', 'ร้านค้า msquare', 'retail m-square']
  },
  {
    code: 'ครัวลำดวน',
    th: 'ครัวลำดวน',
    en: 'Krua Lamduan Restaurant',
    aliases: ['krua lamduan', 'lamduan kitchen', 'ครัวลำดวน', 'ร้านครัวลำดวน', 'lamduan food']
  },
  {
    code: 'คาร์แคร์อาคาร E4',
    th: 'คาร์แคร์ อาคาร E4',
    en: 'Car Care Center E4',
    aliases: ['car care', 'car wash', 'คาร์แคร์', 'ล้างรถ', 'e4 car care', 'car care e4']
  },
  {
    code: 'ตู้หยอดเหรียญสินค้าอัตโนมัติ',
    th: 'ตู้หยอดเหรียญสินค้าอัตโนมัติ',
    en: 'Vending Machine',
    aliases: ['vending machine', 'vending', 'ตู้หยอดเหรียญ', 'ตู้ขายของอัตโนมัติ']
  },
  {
    code: 'ร้าน Trois Monts',
    th: 'ร้าน Trois Monts',
    en: 'Trois Monts Bakery & Cafe',
    aliases: ['trois monts', 'troismonts', 'trois', 'troi', 'ตรัวส์มองต์', 'ทัวมอง', '3 monts']
  },
  {
    code: 'ร้านชงชาอาคาร AV',
    th: 'ร้านชงชา อาคาร AV',
    en: 'Chong Cha Tea Shop (AV)',
    aliases: ['chong cha', 'chongcha', 'tea shop av', 'ชงชา', 'ร้านชงชา']
  },
  {
    code: 'ร้านซักอบรีด',
    th: 'ร้านซักอบรีด',
    en: 'Laundry Service Shop',
    aliases: ['laundry', 'laundry service', 'ซักอบรีด', 'ร้านซักรีด', 'ซักผ้า']
  },
  {
    code: 'ร้านทำเล็บหอพักนานาชาติ',
    th: 'ร้านทำเล็บ หอพักนานาชาติ (IB)',
    en: 'Nail Salon (International Dorm IB)',
    aliases: ['nail salon', 'nail shop', 'ทำเล็บ', 'ร้านทำเล็บ', 'nail salon ib']
  },
  {
    code: 'ร้านมาม่าคาเฟ่อาคาร E4',
    th: 'ร้านมาม่าคาเฟ่ อาคาร E4',
    en: 'Mama Cafe (E4)',
    aliases: ['mama cafe', 'mamacafe', 'มาม่าคาเฟ่', 'มาม่า', 'mama cafe e4']
  },
  {
    code: 'ร้านมินิมาร์ทหอพักนานาชาติ',
    th: 'มินิมาร์ท หอพักนานาชาติ (IB)',
    en: 'Minimart (International Dorm IB)',
    aliases: ['minimart ib', 'convenience store ib', 'มินิมาร์ท ib', 'มินิมาร์ทนานาชาติ']
  },
  {
    code: 'ร้านมินิมาร์ทอาคารสันทนาการ',
    th: 'มินิมาร์ท อาคารสันทนาการ',
    en: 'Minimart (Recreation Building)',
    aliases: ['minimart recreation', 'มินิมาร์ท สันทนาการ', 'มินิมาร์ท']
  },

  // 67-68: Lamduan 8 & 9
  {
    code: 'ลำดวน 8 อาคารที่พักบุคลากรทางการแพทย์',
    th: 'ลำดวน 8 (อาคารที่พักบุคลากรทางการแพทย์)',
    en: 'Lamduan 8 Medical Staff Residence',
    aliases: ['lamduan 8', 'lamduan8', 'ลำดวน 8', 'ลำดวน8', 'medical staff residence', 'หอลำดวน 8', 'dorm lamduan 8']
  },
  {
    code: 'ลำดวน 9 วนาเวศน์',
    th: 'ลำดวน 9 (วนาเวศน์)',
    en: 'Lamduan 9 Wanawes Residence',
    aliases: ['lamduan 9', 'lamduan9', 'wanawes 9', 'ลำดวน 9', 'ลำดวน9', 'วนาเวศน์ 9', 'wanawes', 'wanawet', 'vanaves', 'dorm lamduan 9']
  },

  // 69-70: Wanasom & Sirindhorn Center
  {
    code: 'วนาศรม',
    th: 'วนาศรม (Wanasom Resort)',
    en: 'Wanasom Resort & Wellness Sanctuary',
    aliases: ['wanasom', 'wanasom resort', 'วนาศรม']
  },
  {
    code: 'ศูนย์ภาษาและวัฒธรรมจีนสิรินธร',
    th: 'ศูนย์ภาษาและวัฒนธรรมจีนสิรินธร',
    en: 'Sirindhorn Chinese Language & Culture Center',
    aliases: ['sirindhorn chinese center', 'chinese center', 'ศูนย์จีนสิรินธร', 'ภาษาจีนสิรินธร', 'สิรินธร']
  },

  // 71-75: Food Courts
  {
    code: 'ศูนย์อาหาร C5',
    th: 'ศูนย์อาหาร C5',
    en: 'C5 Food Court',
    aliases: ['food court c5', 'c5 food court', 'canteen c5', 'c5 canteen', 'ศูนย์อาหาร c5', 'โรงอาหาร c5']
  },
  {
    code: 'ศูนย์อาหาร D1',
    th: 'ศูนย์อาหาร D1',
    en: 'D1 Food Court',
    aliases: ['food court d1', 'd1 food court', 'canteen d1', 'd1 canteen', 'ศูนย์อาหาร d1', 'โรงอาหาร d1']
  },
  {
    code: 'ศูนย์อาหาร E1',
    th: 'ศูนย์อาหาร E1',
    en: 'E1 Food Court',
    aliases: ['food court e1', 'e1 food court', 'canteen e1', 'e1 canteen', 'ศูนย์อาหาร e1', 'โรงอาหาร e1']
  },
  {
    code: 'ศูนย์อาหาร E2',
    th: 'ศูนย์อาหาร E2',
    en: 'E2 Food Court',
    aliases: ['food court e2', 'e2 food court', 'canteen e2', 'e2 canteen', 'ศูนย์อาหาร e2', 'โรงอาหาร e2']
  },
  {
    code: 'ศูนย์อาหาร M-Square',
    th: 'ศูนย์อาหาร M-Square',
    en: 'M-Square Food Court',
    aliases: ['food court m-square', 'msquare food court', 'canteen msquare', 'ศูนย์อาหาร m-square', 'ศูนย์อาหาร msquare', 'food court msquare']
  },

  // 76-77: Confucius & Book Center
  {
    code: 'สถาบันขงจื่อ',
    th: 'สถาบันขงจื่อ',
    en: 'Confucius Institute',
    aliases: ['confucius institute', 'confucius', 'ขงจื่อ', 'สถาบันขงจื่อ']
  },
  {
    code: 'สำนักงานศูนย์หนังสือ',
    th: 'สำนักงานศูนย์หนังสือ',
    en: 'MFU Book Center Office',
    aliases: ['book center', 'bookstore', 'book store', 'ศูนย์หนังสือ', 'สำนักงานศูนย์หนังสือ']
  },

  // 78: Makham Pom Dormitory
  {
    code: 'หอพักมะขามป้อม',
    th: 'หอพักมะขามป้อม',
    en: 'Makhampom Dormitory',
    aliases: ['makhampom', 'makham pom', 'makham', 'มะขามป้อม', 'หอมะขามป้อม', 'dorm makhampom']
  },

  // 79-85: Lamduan Student Dormitories (1-7)
  {
    code: 'หอพักลำดวน 1',
    th: 'หอพักลำดวน 1',
    en: 'Lamduan Dormitory 1',
    aliases: ['lamduan 1', 'lamduan1', 'ลำดวน 1', 'ลำดวน1', 'หอลำดวน 1', 'dorm lamduan 1']
  },
  {
    code: 'หอพักลำดวน 2',
    th: 'หอพักลำดวน 2',
    en: 'Lamduan Dormitory 2',
    aliases: ['lamduan 2', 'lamduan2', 'ลำดวน 2', 'ลำดวน2', 'หอลำดวน 2', 'dorm lamduan 2']
  },
  {
    code: 'หอพักลำดวน 3',
    th: 'หอพักลำดวน 3',
    en: 'Lamduan Dormitory 3',
    aliases: ['lamduan 3', 'lamduan3', 'ลำดวน 3', 'ลำดวน3', 'หอลำดวน 3', 'dorm lamduan 3']
  },
  {
    code: 'หอพักลำดวน 4',
    th: 'หอพักลำดวน 4',
    en: 'Lamduan Dormitory 4',
    aliases: ['lamduan 4', 'lamduan4', 'ลำดวน 4', 'ลำดวน4', 'หอลำดวน 4', 'dorm lamduan 4']
  },
  {
    code: 'หอพักลำดวน 5',
    th: 'หอพักลำดวน 5',
    en: 'Lamduan Dormitory 5',
    aliases: ['lamduan 5', 'lamduan5', 'ลำดวน 5', 'ลำดวน5', 'หอลำดวน 5', 'dorm lamduan 5']
  },
  {
    code: 'หอพักลำดวน 6',
    th: 'หอพักลำดวน 6',
    en: 'Lamduan Dormitory 6',
    aliases: ['lamduan 6', 'lamduan6', 'ลำดวน 6', 'ลำดวน6', 'หอลำดวน 6', 'dorm lamduan 6']
  },
  {
    code: 'หอพักลำดวน 7',
    th: 'หอพักลำดวน 7',
    en: 'Lamduan Dormitory 7',
    aliases: ['lamduan 7', 'lamduan7', 'ลำดวน 7', 'ลำดวน7', 'หอลำดวน 7', 'dorm lamduan 7']
  },

  // 86-88: Saktong Student Dormitories (1-3)
  {
    code: 'หอพักสักทอง 1',
    th: 'หอพักสักทอง 1',
    en: 'Saktong Dormitory 1',
    aliases: ['saktong 1', 'saktong1', 'sak tong 1', 'sakthong 1', 'สักทอง 1', 'สักทอง1', 'หอสักทอง 1', 'dorm saktong 1']
  },
  {
    code: 'หอพักสักทอง 2',
    th: 'หอพักสักทอง 2',
    en: 'Saktong Dormitory 2',
    aliases: ['saktong 2', 'saktong2', 'sak tong 2', 'sakthong 2', 'สักทอง 2', 'สักทอง2', 'หอสักทอง 2', 'dorm saktong 2']
  },
  {
    code: 'หอพักสักทอง 3',
    th: 'หอพักสักทอง 3',
    en: 'Saktong Dormitory 3',
    aliases: ['saktong 3', 'saktong3', 'sak tong 3', 'sakthong 3', 'สักทอง 3', 'สักทอง3', 'หอสักทอง 3', 'dorm saktong 3']
  },

  // 89-99: Campus Venues, Schools, Facilities
  {
    code: 'อาคารกีฬาเฉลิมพระเกียรติ 72 พรรษา บรมราชินีนาถ',
    th: 'อาคารกีฬาเฉลิมพระเกียรติ 72 พรรษา',
    en: "72nd Anniversary Queen's Stadium & Sports Center",
    aliases: ['stadium 72', 'sports complex', '72nd stadium', 'กีฬา 72 พรรษา', 'สนามกีฬา 72 พรรษา', 'เฉลิมพระเกียรติ 72 พรรษา']
  },
  {
    code: 'อาคารจัดเก็บเอกสาร',
    th: 'อาคารจัดเก็บเอกสาร',
    en: 'Document Archive Building',
    aliases: ['document archive', 'document storage', 'archive', 'จัดเก็บเอกสาร']
  },
  {
    code: 'อาคารวนาเวศน์',
    th: 'อาคารวนาเวศน์',
    en: 'Wanawes Building',
    aliases: ['wanawes', 'wanawet', 'vanaves', 'วนาเวศน์', 'อาคารวนาเวศน์', 'wanawes building']
  },
  {
    code: 'อาคารศูนย์กีฬาอเนกประสงค์',
    th: 'อาคารศูนย์กีฬาอเนกประสงค์',
    en: 'Multipurpose Gymnasium & Sports Center',
    aliases: ['gym', 'gymnasium', 'indoor stadium', 'sports center', 'ศูนย์กีฬาอเนกประสงค์', 'ศูนย์กีฬา', 'โรงยิม']
  },
  {
    code: 'อาคารสำนักงานสวนพฤกษศาตร์ มหาวิทยาแม่ฟ้าหลวง เฉลิมพระเกียรติ 80 พรรษา มหาราชา',
    th: 'สำนักงานสวนพฤกษศาสตร์ มฟล.',
    en: 'Botanical Garden Office',
    aliases: ['botanical garden', 'botany', 'สวนพฤกษศาสตร์', 'สวนพฤกษศาสตร์ 80 พรรษา']
  },
  {
    code: 'อาคารสำนักวิชาทันตแพทย์',
    th: 'อาคารสำนักวิชาทันตแพทยศาสตร์',
    en: 'School of Dentistry Building',
    aliases: ['dentistry', 'dental', 'school of dentistry', 'ทันตแพทย์', 'ทันตแพทยศาสตร์', 'หมอฟัน']
  },
  {
    code: 'อาคารสำนักวิชาแพทย์ศาสตร์',
    th: 'อาคารสำนักวิชาแพทยศาสตร์',
    en: 'School of Medicine Building',
    aliases: ['medicine', 'medical school', 'school of medicine', 'แพทย์ศาสตร์', 'แพทยศาสตร์', 'หมอ']
  },
  {
    code: 'เครื่องซักผ้าหยอดเหรียญ',
    th: 'เครื่องซักผ้าหยอดเหรียญ',
    en: 'Coin-operated Washing Machines',
    aliases: ['coin washing machine', 'laundromat', 'washing machine', 'เครื่องซักผ้า', 'ซักผ้าหยอดเหรียญ']
  },
  {
    code: 'เรือนริมน้ำ',
    th: 'เรือนริมน้ำ',
    en: 'Ruen Rim Nam Waterfront Pavilion',
    aliases: ['rimnam', 'rim nam', 'ruen rim nam', 'waterfront pavilion', 'เรือนริมน้ำ', 'ริมน้ำ']
  },
  {
    code: 'โถงร้านค้า S2',
    th: 'โถงร้านค้า S2',
    en: 'S2 Retail Hall',
    aliases: ['s2 retail', 's2 shops', 's2 shop', 'โถงร้านค้า s2', 'ร้านค้า s2']
  },
  {
    code: 'โรงผลิตประปา',
    th: 'โรงผลิตประปา',
    en: 'Water Treatment Plant',
    aliases: ['water treatment plant', 'water plant', 'water treatment', 'โรงประปา', 'ประปา']
  }
];

/**
 * Normalizes query string for fuzzy comparison by stripping punctuation, spaces, and lowering case.
 */
export function normalizeQuery(str) {
  if (!str) return '';
  return String(str)
    .trim()
    .toLowerCase()
    .replace(/[\s\-_/\\,.:;()]+/g, '');
}

/**
 * Finds the directory entry for a building object or building code string.
 * @param {string|Object} buildingOrCode
 * @returns {Object|null}
 */
export function findDirectoryEntry(buildingOrCode) {
  const bCode = typeof buildingOrCode === 'object' && buildingOrCode
    ? String(buildingOrCode.BUILDINGCODE || buildingOrCode.name || buildingOrCode.code || '')
    : String(buildingOrCode || '');
  if (!bCode) return null;

  const bNorm = normalizeQuery(bCode);
  if (!bNorm) return null;

  // 1. Exact match on entry code
  for (const entry of MFU_BUILDING_DIRECTORY) {
    if (normalizeQuery(entry.code) === bNorm) {
      return entry;
    }
  }

  // 2. Prefix or substring match on entry code
  for (const entry of MFU_BUILDING_DIRECTORY) {
    const entryCodeNorm = normalizeQuery(entry.code);
    if (entryCodeNorm.startsWith(bNorm) || bNorm.startsWith(entryCodeNorm) ||
        entryCodeNorm.includes(bNorm) || bNorm.includes(entryCodeNorm)) {
      return entry;
    }
  }

  return null;
}

/**
 * Returns the canonical English name for a building.
 * @param {string|Object} building
 * @returns {string}
 */
export function getBuildingEnglishName(building) {
  if (building && typeof building === "object" && building.BUILDINGNAME_EN) return building.BUILDINGNAME_EN;
  const entry = findDirectoryEntry(building);
  return entry ? (entry.en || '') : '';
}

/**
 * Returns a bilingual display label for a building.
 * @param {string|Object} building
 * @param {string} [locale='th']
 * @returns {string}
 */
export function getBuildingLocalizedName(building, locale = 'th') {
  if (!building) return '';
  const entry = findDirectoryEntry(building);
  const legacy = typeof building === 'object'
    ? (building.BUILDINGCODE || building.buildingCode || building.name || '') : String(building);
  const thai = typeof building === 'object' && building.BUILDINGNAME_TH
    ? building.BUILDINGNAME_TH : (entry && entry.th) || legacy;
  const english = getBuildingEnglishName(building);
  return String(locale).toLowerCase().startsWith('en') ? english || thai : thai || english;
}

export function getBuildingDisplayName(building, locale = 'th') {
  if (!building) return '';
  const thName = typeof building === 'object'
    ? (building.BUILDINGNAME_TH || building.BUILDINGCODE || building.BUILDINGNAME || building.name || '')
    : String(building);
  const enName = getBuildingEnglishName(building);

  if (locale === 'en') {
    if (enName && thName && enName !== thName) {
      return `${enName} (${thName})`;
    }
    return enName || thName;
  }

  // default / Thai locale
  if (enName && thName && enName !== thName) {
    return `${thName} (${enName})`;
  }
  return thName;
}

/**
 * Checks whether a ticket's building matches a search query using bilingual mapping.
 * Supports Thai names, English names, abbreviations, and romanized aliases.
 * @param {string|Object} building
 * @param {string} rawQuery
 * @returns {boolean}
 */
export function matchesBuildingQuery(building, rawQuery) {
  if (!rawQuery) return false;
  const qNorm = normalizeQuery(rawQuery);
  if (!qNorm) return false;

  const bCode = typeof building === 'object' && building
    ? String(building.BUILDINGCODE || building.name || building.code || '')
    : String(building || '');

  if (!bCode) return false;

  if (building && typeof building === "object" &&
      [building.BUILDINGNAME_TH, building.BUILDINGNAME_EN].some(name => name && normalizeQuery(name).includes(qNorm))) return true;
  const bNorm = normalizeQuery(bCode);

  // 1. Direct match between code and query
  if (bNorm.includes(qNorm) || qNorm.includes(bNorm)) {
    return true;
  }

  // 2. Look up directory entry
  const entry = findDirectoryEntry(bCode);
  if (entry) {
    // Check Thai name
    const thNorm = normalizeQuery(entry.th);
    if (thNorm && (thNorm.includes(qNorm) || qNorm.includes(thNorm))) {
      return true;
    }

    // Check English name
    const enNorm = normalizeQuery(entry.en);
    if (enNorm && (enNorm.includes(qNorm) || qNorm.includes(enNorm))) {
      return true;
    }

    // Check aliases
    for (const alias of entry.aliases || []) {
      const aliasNorm = normalizeQuery(alias);
      if (aliasNorm && (aliasNorm.includes(qNorm) || qNorm.includes(aliasNorm))) {
        return true;
      }
    }
  }

  return false;
}

/**
 * Checks whether a ticket matches a search query across all key fields,
 * including bilingual building, room, ticket number, reporter, description, category, and status.
 * @param {Object} ticket
 * @param {string} rawQuery
 * @returns {boolean}
 */
export function matchTicketBilingual(ticket, rawQuery) {
  if (!ticket || !rawQuery || !rawQuery.trim()) return false;
  const q = rawQuery.trim().toLowerCase();
  const qNorm = normalizeQuery(rawQuery);

  // 1. Ticket Number / ID
  const tNo = String(ticket.ticketNumber || ticket.ticketNo || ticket._id || ticket.id || '').toLowerCase();
  if (tNo.includes(q)) return true;

  // 2. User Part
  const u = ticket.userPart || {};

  // 2a. Problem Details
  const prob = String(u.problemDetails || '').toLowerCase();
  if (prob.includes(q)) return true;

  // 2b. Location - Building (Bilingual check)
  const bObj = u.buildingLocation && u.buildingLocation.building;
  if (matchesBuildingQuery(bObj, rawQuery)) return true;

  // 2c. Location - Room
  const room = String((u.buildingLocation && u.buildingLocation.roomName) || '').toLowerCase();
  if (room.includes(q)) return true;

  // 2d. Location - Outdoor / Details
  const locDetail = String(u.locationDetail || '').toLowerCase();
  if (locDetail.includes(q)) return true;

  // 2e. Reporter info
  const repName = String(
    u.user ? `${u.user.name || ''} ${u.user.surname || ''}` : (u.fullname || u.username || '')
  ).toLowerCase();
  if (repName.includes(q)) return true;

  const repDept = String(
    (u.category && u.category.departmentName) || u.department || ''
  ).toLowerCase();
  if (repDept.includes(q)) return true;

  const repAffil = String(
    (u.user?.affiliation && typeof u.user.affiliation === 'object' ? u.user.affiliation.name : u.user?.affiliation) || ''
  ).toLowerCase();
  if (repAffil && repAffil.includes(q)) return true;

  // 2f. Subcategory / Category
  const cat = String(u.subCategory && u.subCategory.name ? u.subCategory.name : (u.subCategory || u.otherCategoryText || '')).toLowerCase();
  if (cat.includes(q)) return true;

  // 3. Status (Bilingual check)
  const status = String(ticket.status || '').toLowerCase();
  const statusLabels = {
    pending: ['pending', 'รอรับเรื่อง', 'แจ้งเรื่อง', 'รอดำเนินการ'],
    assigned: ['assigned', 'มอบหมายช่าง', 'รับเรื่อง', 'มอบหมาย'],
    in_progress: ['in_progress', 'inprogress', 'กำลังซ่อม', 'ดำเนินการ'],
    done: ['done', 'repaired', 'ซ่อมเสร็จ', 'รอประเมิน'],
    welldone: ['welldone', 'rated', 'ประเมินแล้ว', 'เสร็จสิ้น', 'เรียบร้อย'],
    cancelled: ['cancelled', 'cancel', 'ยกเลิก']
  };
  const list = statusLabels[status] || [status];
  if (list.some(s => s.toLowerCase().includes(q))) return true;

  return false;
}

/**
 * Keywords identifying locations belonging to the Property & Revenue Management Office (สำนักงานจัดการทรัพย์สินและรายได้).
 * Corresponds to all 22 locations listed in the official property location sheet.
 */
export const PROPERTY_LOCATION_KEYWORDS = [
  'อาคารวนาเวศน์',
  'วนาเวศน์',
  'wanawes',
  'wanawet',
  'vanaves',
  'สำนักงานศูนย์หนังสือ',
  'ศูนย์หนังสือ',
  'book center',
  'bookstore',
  'm-store',
  'mstore',
  'ศูนย์อาหาร e1',
  'ศูนย์อาหาร e2',
  'ศูนย์อาหาร c5',
  'ศูนย์อาหาร d1',
  'ศูนย์อาหาร m-square',
  'ศูนย์อาหาร m-sqaure',
  'ศูนย์อาหาร',
  'food court',
  'foodcourt',
  'canteen',
  'ครัวลำดวน',
  'krua lamduan',
  'โถงร้านค้า s2',
  'โถงร้านค้าs2',
  'โถงร้านค้า',
  'ร้านชงชาอาคาร av',
  'ร้านชงชาอาคารav',
  'ร้านชงชา',
  'chong cha',
  'เรือนริมน้ำ',
  'rimnam',
  'กลุ่มร้านค้าอาคาร m-square',
  'กลุ่มร้านค้าอาคาร m-sqaure',
  'กลุ่มร้านค้า m-square',
  'ร้าน trois monts',
  'trois monts',
  'troismonts',
  'trois',
  'troi',
  'ร้านมินิมาร์ทอาคารสันทนาการ',
  'มินิมาร์ทอาคารสันทนาการ',
  'ร้านซักอบรีด',
  'ซักอบรีด',
  'laundry',
  'เครื่องซักผ้าหยอดเหรียญ',
  'คาร์แคร์อาคาร e4',
  'คาร์แคร์',
  'car care',
  'ร้านมาม่าคาเฟ่อาคาร e4',
  'มาม่าคาเฟ่',
  'mama cafe',
  'ตู้หยอดเหรียญสินค้าอัตโนมัติ',
  'ตู้หยอดเหรียญ',
  'vending',
  'ร้านมินิมาร์ทหอพักนานาชาติ',
  'มินิมาร์ทหอพักนานาชาติ',
  'ร้านทำเล็บหอพักนานาชาติ',
  'ทำเล็บหอพักนานาชาติ',
  'nail salon',
];

/**
 * Checks whether a building, building code, or location string belongs to the Property & Revenue Office.
 * @param {string|Object} buildingOrCode
 * @returns {boolean}
 */
export function isPropertyLocationBuilding(buildingOrCode) {
  if (!buildingOrCode) return false;
  const raw = typeof buildingOrCode === 'object'
    ? String(buildingOrCode.BUILDINGCODE || buildingOrCode.BUILDINGNAME || buildingOrCode.name || buildingOrCode.code || '')
    : String(buildingOrCode);
  const norm = normalizeQuery(raw);
  if (!norm) return false;

  const matchKw = PROPERTY_LOCATION_KEYWORDS.some(kw => {
    const normKw = normalizeQuery(kw);
    return normKw && norm.includes(normKw);
  });
  if (matchKw) return true;

  const entry = findDirectoryEntry(buildingOrCode);
  if (entry) {
    const entryNorm = normalizeQuery(entry.code + ' ' + (entry.th || '') + ' ' + (entry.en || ''));
    return PROPERTY_LOCATION_KEYWORDS.some(kw => {
      const normKw = normalizeQuery(kw);
      return normKw && entryNorm.includes(normKw);
    });
  }

  return false;
}


// Room policy is independent of repair routing / property ownership.
export function requiresBuildingRoom(building) {
  if (!building) return false;
  const raw = typeof building === 'object' ? building.BUILDINGCODE || building.buildingCode || '' : String(building);
  return /^(?:C[1-5]|E[1-4](?:-[AB])?|S[1-7](?:-[AB])?|M3|AD2?|AS)(?=\s|$)/i.test(raw.trim()) ||
    /หอพัก|ที่พัก|บ้านพัก/.test(raw) || /^(?:CN[12]|IB|A[12]-[1-4]|F[1-6]|H[1-5])(?=\s|$)/i.test(raw.trim());
}
